import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Injectable, Injector, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { BaseCrudService, downloadedFile } from 'src/app/services/base-crud/base-crud.service';

export interface Widget {
  id?: string;
  label?: string;
  component: any;
  inputs: any;
  outputs: any;
}

export interface PaginationOptions {
  index: number, size: number, length: number
}

@Injectable({
  providedIn: 'root'
})
export abstract class CrudComAbasComponent<T> implements OnInit {
  public abstract habilitarInclusao: boolean;
  public abstract habilitarEditacao: boolean;

  public exibeBotaoNovo: boolean = true;

  public abstract titulo: string;
  public abstract subtitulo: string;
  public botaonovo: string;
  public abstract componenteFiltro: Widget;
  public abstract formPesquisa: FormGroup;
  public abstract componenteGrid: Widget;

  public tabIndex: number = 0;
  public arrayAbas: Widget[] = [];

  public isLoading: boolean = false;
  public isLoadingDownload: boolean = false;
  public exibirGrid: boolean = false;
  public paging: PaginationOptions = { index: 0, length: 0, size: 10 };

  public filters: any = {};

  get gridData(): any[] {
    return this.componenteGrid.inputs.gridData;
  }

  set gridData(data: any[]) {
    this.componenteGrid.inputs.gridData = data;
  }

  public abstract novo(item: T): void;
  public abstract alterar(item: T): void;

  public featureId;

  public snackBar: MatSnackBar;
  public route: ActivatedRoute;
  public change: ChangeDetectorRef;

  @ViewChild('tabGroup') public abstract tabGroup: MatTabGroup;

  constructor(
    public injectorObj: Injector,
    public service: BaseCrudService
  ) {
    this.snackBar = this.injectorObj.get(MatSnackBar);
    this.route = this.injectorObj.get(ActivatedRoute);
    this.change = this.injectorObj.get(ChangeDetectorRef);

    this.featureId = this.route.snapshot.data['FEATURE_ID'];

    this.isLoading = false;
    this.isLoadingDownload = false;
    this.exibirGrid = false;
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   this.isLoading = changes.isLoading.currentValue;
  //   this.isLoadingDownload = changes.isLoadingDownload.currentValue;
  //   this.exibirGrid = changes.exibirGrid.currentValue;
  // }

  ngOnInit() {
  }

  public setFilterComponent(component,
    inputs = {},
    outputs = {},
    id = null,
    label = null) {
    this.componenteFiltro = {
      id: id,
      label: label,
      component: component,
      inputs: {
        ...inputs,
        parent: this,
        formPesquisa: this.formPesquisa,
      },
      outputs: {
        ...outputs
      }
    };
  }

  public setGridComponent(component,
    inputs = {},
    outputs = {},
    id = null,
    label = null) {
    this.componenteGrid = {
      id: id,
      label: label,
      component: component,
      inputs: {
        ...inputs,
        parent: this
      },
      outputs: outputs
    };
  }

  public alterarPorId(id) {
    this.isLoading = true;
    this.gridData = null;

    this.service
      .consultarPorId(id)
      .subscribe(
        (response) => {
          this.exibirGrid = true;
          if (response) {
            this.alterar(response[0]);
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro ao consultar " + err.error + "! Tente novamente",
            "OK",
            3000,
            "danger-snackbar"
          );
        }
      )
      .add(() => {
        this.isLoading = false;
      });
  }
  public setPage(p) {
    this.paging.index = p;
  }
  public setTotalPerPage(p) {
    this.paging.size = p;
  }
  public carregarGrid(request = null) {
    if (!request) request = this.filters;

    this.isLoading = true;
    this.gridData = null;
    this.exibirGrid = true;
    this.paging.index = request.paginaAtual ? request.paginaAtual - 1 : this.paging.index;

    this.changeTabIndex(0);

    this.filters = {
      ...request,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    };
    this.service
      .consultar(this.filters)
      .subscribe({
        next: (response: any = []) => {
          this.gridData = response;
          this.exibirGrid = true;
          if (response.length > 0) {
          this.paging.length = response[0].totalCount;
          }
        },
        error: (error: HttpErrorResponse) => {
          console.error(error);
          this.openSnackBar(
            "Ocorreu um erro ao consultar " + error.error + "! Tente novamente",
            "OK",
            3000,
            "danger-snackbar"
          );
        },
        complete: () => {
          this.isLoading = false;
        }
      })
      // .subscribe(
      //   (res: any=[]) =>  {
      //     this.gridData = res;
      //     this.exibirGrid = true;
      //     if (res.length > 0) {
      //       this.paging.length = res[0].totalCount;
      //     }
      //   },
      //   (err: HttpErrorResponse) => {
      //     console.error(err);
      //     this.openSnackBar(
      //       "Ocorreu um erro ao consultar " + err.error + "! Tente novamente",
      //       "OK",
      //       3000,
      //       "danger-snackbar"
      //     );
      //   }
      // )
      // .add(() => {
      //   this.isLoading = false;
      // });
  }

  public excel() {
    this.isLoadingDownload = true;
    this.service.excel(this.filters,
      (response) => this.gerarArquivo(response),
      (err) => console.log(err))
      .add(() => (this.isLoadingDownload = false));
  }

  public clearFields() {
    this.formPesquisa.reset();
    this.arrayAbas = [];
    this.changeTabIndex(0);
    this.gridData = null;
    this.exibirGrid = false;
  }

  public addTab(component, inputs, outputs, id, label) {
    let item = this.createWidget(component, { ...inputs }, { ...outputs }, id, label);
    if (!this.checkExistTab(item)) {
      this.arrayAbas.unshift(item);
      this.changeTabIndex(1);
    }
  }

  public addTabCadastro(component, inputs, outputs, id, label) {
    let item = this.createWidget(component,
      {
        ...inputs
      }, {
      ...outputs,
      onSave: (response) => this.onSave(item, response)
    }, id, label);
    if (!this.checkExistTab(item)) {
      this.arrayAbas.unshift(item);
      this.changeTabIndex(1);
    }
  }

  public openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  public removerTabItem(item: Widget) {
    let idx = this.arrayAbas.indexOf(item);
    if (idx != -1) this.removerTab(idx);
  }

  public removerTab(index: number, event?: MouseEvent) {
    if (event) event.preventDefault();
    this.arrayAbas.splice(index, 1);
  }

  public removerTabByKey(key: string) {
    let idx = this.arrayAbas.findIndex((d) => d.id == key);
    if (idx != -1) this.removerTab(idx);
  }

  public checkExistTab(item: Widget) {
    let idx = this.arrayAbas.findIndex((d) => d.id == item.id);
    const exists = idx !== -1;
    if (exists) {
      //atualizar item para receber dados mais recentes
      this.arrayAbas[idx] = item;
      this.changeTabIndex(idx + 1);
    }

    return exists;
  }

  public createWidget(component,
    inputs = {},
    outputs = {},
    id = null,
    label = null) {
    let retorno: Widget = {
      id: id,
      label: label,
      component: component,
      inputs: {
        ...inputs,
        parent: this,
      },
      outputs: {
        ...outputs
      }
    };
    return retorno;
  }


  public changeTabIndex(index) {
    setTimeout(() => {
      this.tabGroup.selectedIndex = index;
      this.change.markForCheck();

    }, 100);
  }

  public onPageChange(evt) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.filters.paginaAtual = evt.pageIndex + 1;
    this.filters.itensPorPagina = evt.pageSize;
    this.carregarGrid();
  }

  public tooltipHelp(campo) {
    return `${campo}#${this.featureId}`;
  }

  private gerarArquivo(file: downloadedFile) {
    const url = window.URL.createObjectURL(file.blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public onSave(tabItem: Widget, response: any): void {
    if (response === "OK" || response?.status == 200 || response?.status == 201) {
      this.removerTabItem(tabItem);
      this.carregarGrid();
    } else if (response.action === "EDITAR") {
      this.removerTabItem(tabItem);
      this.alterarPorId(response.id);
    }
  }
}
